import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';

export interface TransferTabExtraContextValue {
  tabExtra: ReactNode;
  setTabExtra: (node: ReactNode) => void;
}

export const TransferTabExtraContext = createContext<TransferTabExtraContextValue>({
  tabExtra: null,
  setTabExtra: () => {},
});

export function TransferTabExtraProvider({ children }: { children: ReactNode }) {
  const [tabExtra, setTabExtra] = useState<ReactNode>(null);

  return (
    <TransferTabExtraContext.Provider value={{ tabExtra, setTabExtra }}>
      {children}
    </TransferTabExtraContext.Provider>
  );
}

type TabExtraContent = ReactNode | (() => ReactNode);

/** Register toolbar content shown to the right of transfer route tabs. */
export function useTransferTabExtraContent(content: TabExtraContent, deps: unknown[]) {
  const { setTabExtra } = useContext(TransferTabExtraContext);

  useEffect(() => {
    setTabExtra(typeof content === 'function' ? content() : content);
    return () => setTabExtra(null);
  }, deps);
}
